import React, { useEffect } from "react";
import SEO from "../Components/Seo";
import Header from "../Components/Nav/Header";
import Footer from "../Components/Nav/Footer";
import Contact from "../Components/Main/Contact";
import Hero from "../Components/Main/Hero";
import History from "../Components/Main/History";
import MVV from "../Components/Main/MVV";
import Connect from "../Components/Main/Connect";
import Insight from "../Components/Main/Insight";
import OurProducts from "../Components/Main/OurProducts";

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="bg-[#FBFBF8]">
      <SEO
        title={""}
        description={""}
        name={"Greengate Pharmaceuticals"}
        type={"article"}
      />
      <Header />
      <Hero />
      <History />
      <MVV />
      <OurProducts />
      <Insight />
      <Connect />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
